import React, { useState, useRef, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "./Components/Header/Header";
import axios from "axios";
import "./assets/styles/CreateEvent.css";
import { API_PET_URL } from "./endpoints";

const CreatePetPublic = () => {
    const [isImageUploaded, setIsImageUploaded] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [step, setStep] = useState(1); // Step state to control form flow
    const [petId, setPetId] = useState("");
    const [petColor, setPetColor] = useState("");
    const [intolerance, setIntolerance] = useState("");
    const [petType, setPetType] = useState(""); // tipo
    const [petName, setPetName] = useState(""); // nombre
    const [petGender, setPetGender] = useState(""); // género
    const [petBreed, setPetBreed] = useState(""); // raza
    const [dateBirth, setDateBirth] = useState(""); // fecha nacimiento
    const [petCharacter, setPetCharacter] = useState(""); // caracter
    const [microChip, setMicrochip] = useState(""); // microchip
    const [microChipNumber, setMicrochipNumber] = useState(""); // microchip

    const [fleaCollar, setFleaCollar] = useState(""); // microchip
    const [fleaCollarDate, setFleaCollarDate] = useState(""); // microchip


    const [sterilized, setSterilized] = useState("")
    const [petVaccine, setPetVaccine] = useState("")
    const [dateLastVaccine, setDateLastVaccine] = useState("")
    const [description, setDescription] = useState("");
    const [location, setLocation] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [ownerEmail, setOwnerEmail] = useState("")
    const [recommendedBy, setRecommendedBy] = useState("")
    const [contactPhone, setContactPhone] = useState("");
    const [colorChapita, setColorChapita] = useState("");
    const [vetAddress, setVetAddress] = useState("")
    const [vetName, setVetName] = useState("");
    const [vetPhone, setVetPhone] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [coverImageUrl, setCoverImageUrl] = useState("");
    const [coverImageFile, setCoverImageFile] = useState(null); // For file upload
    const [customMessage, setCustomMessage] = useState("");
    const [secret, setSecret] = useState(""); // State for secret input
    const [isCreating, setIsCreating] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [successMessageFileUpload, setSuccessMessageFileUpload] = useState("");
    const [errorMessageFileUpload, setErrorMessageFileUpload] = useState("");
    const [eventUrl, setEventUrl] = useState(""); // State to store the event URL
    const fileInputRef = useRef(null);

    const validateRequiredFields = () => {
        return (
            petName && petType && petBreed && petGender && dateBirth && petColor && sterilized && petVaccine && petCharacter 
        );
    };
    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);

    useEffect(() => {
        setIsNextButtonDisabled(!validateRequiredFields());
    }, [petName, petType, petBreed, petGender, dateBirth, petColor, sterilized, petVaccine, petCharacter]);

    const qrCodeRef = useRef(null); // Ref for the QR code

    const [uploadedImageUrl, setUploadedImageUrl] = useState(""); // To store the uploaded image URL
    const [qrCodeFile, setQrCodeFile] = useState(null);
    const [uploadedQRCodeUrl, setUploadedQRCodeUrl] = useState(""); // Added state for uploaded QR code URL
    const [uploadButtonText, setUploadButtonText] = useState("Subir Imagen");
    const hiddenCanvasRef = useRef(null); // For the hidden QR code canvas
    const [maxProfiles, setMaxProfiles] = useState(5); // Default limit

    useEffect(() => {
        // Retrieve user email from localStorage (or session)
        const credentials = JSON.parse(localStorage.getItem("credentials"));
        if (credentials?.email) {
            setUserEmail(credentials.email);
        }
    }, []);

    const handleDateChange = (e) => {
        setDateBirth(e.target.value);
    };

    const handleDateForVaccine = (e) => {
        setDateLastVaccine(e.target.value);
    };

    const handleDateForFlea = (e) => {
        setFleaCollarDate(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsCreating(true);

        const formData = {
            email: "martinembon9@gmail.com", // Assuming you have ownerEmail from the form
            subject: `New Pet Submission: ${petName}`, // You can adjust the subject as needed
            body: `
                Pet Name: ${petName}
                Pet Type: ${petType}
                Pet Breed: ${petBreed}
                Pet Gender: ${petGender}
                Date of Birth: ${dateBirth}
                Pet Color: ${petColor}
                Sterilized: ${sterilized}
                Pet Vaccine: ${petVaccine}
                Date of Last Vaccine: ${dateLastVaccine}
                Pet Character: ${petCharacter}
                Pet Intolerance: ${intolerance}
                Microchip: ${microChip}
                Microchip Number: ${microChipNumber}
                Flea Collar: ${fleaCollar}
                Flea Collar Date: ${fleaCollarDate}
                Owner Name: ${ownerName}
                Owner Email: ${ownerEmail}
                Recommended By: ${recommendedBy}
                Contact Phone: ${contactPhone}
                Location: ${location}
                Vet Name: ${vetName}
                Vet Phone: ${vetPhone}
                Vet Address: ${vetAddress}
                Cover Image: ${uploadedImageUrl}  
                Color Chapita: ${colorChapita}  
            `, // Body of the email, with the pet details formatted
        };

        try {
            const response = await axios.post('https://create-pet-public-867228903962.us-central1.run.app', formData);
            setSuccessMessage('¡Formulario enviado correctamente! <br />Con estos datos, vamos a generar el QR de tu mascota.<br />Te contactaremos cuando esté listo.');
            setErrorMessage('');
            console.log('Email sent successfully', response.data);
            handleReset(); // Reset form after successful submission

        } catch (error) {
            setErrorMessage('Hubo un error al enviar el formulario. Inténtalo nuevamente.');
            setSuccessMessage('');
            console.error('Error sending email', error);
        } finally {
            setIsCreating(false);
        }
    };


    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);

    const handleCreateEvent = async (event) => {
        event.preventDefault();
        if (isCreating) return; // Prevent multiple submissions
        setIsCreating(true);

        // Retrieve user email from localStorage
        const credentials = JSON.parse(localStorage.getItem("credentials"));
        const userEmail = credentials?.email || ""; // If no email found, default to an empty string

        // Add emoji to the customMessage
        const messageWithEmoji = `${customMessage} 🐾✨`;  // Add an emoji at the end


        // When submitting, apply the formatting to the pet name.
        const formattedName = petName
            .trim()  // Remove leading/trailing spaces
            .replace(/\s+/g, ' ') // Replace multiple spaces with one space
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

        // Generate the petId (all lowercase, concatenating formatted name and timestamp)
        const timestamp = Date.now(); // Unique timestamp
        const generatedId = `${formattedName.replace(/\s+/g, '').toLowerCase()}-${timestamp}`;
        setPetId(generatedId);

        // Now submit the data (you can call your API or whatever you need here)
        console.log('Submitting:', formattedName, generatedId);
        // Add your submit logic here...
        setIsCreating(true);
        setErrorMessage("");
        setSuccessMessage("");

        try {
            // Create JSON payload
            const payload = {
                petId: generatedId,
                uploadedImageUrl,
                customMessage: messageWithEmoji,
                petName: formattedName,
                petColor,
                intolerance,
                petType,
                petBreed,
                petCharacter,
                dateBirth,
                microChip,
                microChipNumber,
                fleaCollar,
                fleaCollarDate,
                sterilized,
                petVaccine,
                dateLastVaccine,
                description,
                location,
                ownerName,
                contactPhone,
                vetName,
                vetPhone,
                vetAddress,
                userEmail,
                petGender,
                colorChapita
            };
            // Handle file upload separately if needed
            if (coverImageFile) {
            }

            // Send JSON payload
            const response = await axios.post(API_PET_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.data.success) {

                alert("success")
                // Clear inputs
                setPetId("");
                setCoverImageUrl("");
                setCoverImageFile(null);
                setCustomMessage("");
                setPetColor("")
                setPetName("");
                setIntolerance("")
                setPetType("");
                setPetCharacter("")
                setSterilized("")
                setPetVaccine("")
                setDateLastVaccine("")
                setPetBreed("")
                setDateBirth("");
                setMicrochip("")
                setMicrochipNumber("")
                setFleaCollar("")
                setFleaCollarDate("")
                setSecret(""); // Clear secret input
                setDescription("")
                setLocation("")
                setOwnerName("")
                setContactPhone("")
                setVetName("")
                setVetPhone("")
                setVetAddress("")
                setPetGender("")
                setColorChapita("")
            } else {
                setErrorMessage("Hubo un error al crear el evento.");
            }
        } catch (error) {
            console.error("Error creating event:", error);
            setErrorMessage(`${error.response.data.error}`);
            // setErrorMessage(`Error: ${error.message}`);
        } finally {
            setIsCreating(false);
        }
    };

    // const handleFileUpload = async (event) => {
    //     event.preventDefault();
    //     setErrorMessageFileUpload("");
    //     setSuccessMessageFileUpload("");
    //     if (!coverImageFile) {
    //         setErrorMessageFileUpload("Por favor, selecciona un archivo para subir.");
    //         return null;
    //     }
    //     try {
    //         setUploadButtonText("Subiendo...")

    //         // Step 1: Get the signed URL from the Cloud Function
    //         const response = await axios.post(
    //             "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-cover-photo-album",
    //             {
    //                 filename: coverImageFile.name,
    //                 contentType: coverImageFile.type,
    //             }
    //         );

    //         if (response.status !== 200) {
    //             throw new Error("Failed to get signed URL");
    //         }

    //         const { uploadUrl, publicUrl } = response.data;

    //         // Log the upload URL and public URL for debugging
    //         console.log("Received upload URL:", uploadUrl);
    //         console.log("Public URL:", publicUrl);

    //         // Step 2: Upload the file using the signed URL
    //         const uploadResponse = await axios.put(uploadUrl, coverImageFile, {
    //             headers: {
    //                 "Content-Type": coverImageFile.type, // Make sure the content type matches the file type
    //             },
    //         });

    //         if (uploadResponse.status === 200) {
    //             console.log("File uploaded successfully!");
    //             // Step 3: Update the UI with the public URL
    //             setUploadedImageUrl(publicUrl);
    //             setCoverImageFile(null);
    //             setIsImageUploaded(true);  // Image uploaded successfully
    //             setUploadButtonText("Imagen subida");
    //         } else {
    //             throw new Error("Failed to upload image to Cloud Storage");
    //         }
    //     } catch (error) {
    //         console.error("Error uploading file:", error);
    //         setErrorMessageFileUpload("Error al subir la imagen.");
    //         setUploadButtonText("Subir Imagen"); // Reset button text on error

    //     }
    // };

    const handleFileUpload = async (event) => {
        event.preventDefault();
        setErrorMessageFileUpload("");
        setSuccessMessageFileUpload("");
        if (!coverImageFile) {
            setErrorMessageFileUpload("Por favor, selecciona un archivo para subir.");
            setIsImageUploaded(false);  // Make sure to reset this state if no file is selected

            return null;
        }
        try {
            setUploadButtonText("Subiendo...")

            // Step 1: Get the signed URL from the Cloud Function
            const response = await axios.post(
                "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-cover-photo-album",
                {
                    filename: coverImageFile.name,
                    contentType: coverImageFile.type,
                }
            );

            if (response.status !== 200) {
                throw new Error("Failed to get signed URL");
            }

            const { uploadUrl, publicUrl } = response.data;

            // Log the upload URL and public URL for debugging
            console.log("Received upload URL:", uploadUrl);
            console.log("Public URL:", publicUrl);

            // Step 2: Upload the file using the signed URL
            const uploadResponse = await axios.put(uploadUrl, coverImageFile, {
                headers: {
                    "Content-Type": coverImageFile.type, // Make sure the content type matches the file type
                },
            });

            if (uploadResponse.status === 200) {
                console.log("File uploaded successfully!");
                // Step 3: Update the UI with the public URL
                setUploadedImageUrl(publicUrl);  // Set the public URL of the uploaded image
                setCoverImageFile(null);
                setIsImageUploaded(true);  // Image uploaded successfully
                
                setUploadButtonText("Imagen subida");
            } else {
                throw new Error("Failed to upload image to Cloud Storage");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setErrorMessageFileUpload("Error al subir la imagen.");
            setUploadButtonText("Subir Imagen"); // Reset button text on error
            setIsImageUploaded(false);  // Reset the image uploaded state on error

        }
    };

    const handleReset = () => {
        // Clear all the states related to the form fields
        setCoverImageFile(null);
        setCoverImageUrl("");
        setUploadedImageUrl("");
        setSuccessMessageFileUpload("");
        setErrorMessageFileUpload("");
        setPetId("");
        setPetColor("")
        setVetName("")
        setOwnerEmail("")
        setRecommendedBy("")
        setIntolerance("")
        setVetPhone("")
        setSterilized("")
        setPetVaccine("")
        setDateLastVaccine("")
        setCoverImageUrl("");
        setCoverImageFile(null);
        setCustomMessage("");
        setPetName("");
        setPetType("");
        setPetCharacter("")
        setPetBreed("")
        setDateBirth("");
        setMicrochip("")
        setMicrochipNumber("")
        setFleaCollar("")
        setFleaCollarDate("")
        setSecret(""); // Clear secret input
        setDescription("")
        setLocation("")
        setOwnerName("")
        setContactPhone("")
        setVetAddress("")
        setPetGender("")
        setColorChapita("")
        // Reset the file input value using ref
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
          // Reset image upload states
    setIsImageUploaded(false);
    setUploadButtonText("Subir Imagen"); // Reset the upload button text
    };

    const handlePetNameChange = (e) => {
        setPetName(e.target.value);
    };

    return (
        <div className="create-event-container">
            <Helmet>
                <title>Crear mascota</title>
            </Helmet>
            <Header className="header-with-margin" />
            <button className="reset-button-public" onClick={handleReset}>Limpiar</button>
            <button className="visit-demo" onClick={() => window.open("https://www.pet-connect.shop/pet?petId=catalina-1741435773899", "_blank")}>
  Ver perfil demo
</button>

            <h2>Creá el perfil de tu mascota</h2>

            {/* Step 1: Upload Image */}
            {step === 1 && (

                < form onSubmit={handleFileUpload} className="dotted-border">
                    <label>Elegí la foto de tu mascota y presioná 'Subir imagen'.</label>
                    <input
                        type="file"
                        onChange={(e) => setCoverImageFile(e.target.files[0])}
                        required
                        className="uploadFile"
                        ref={fileInputRef}
                        accept="image/*"  // Only accept image files
                    />
                    <button className="uploadButton" type="submit">{uploadButtonText}</button>
                    {successMessageFileUpload && (
                        <p className="success-message">{successMessageFileUpload}</p>
                    )}

                    {/* Display error message if exists */}
                    {errorMessageFileUpload && (
                        <p className="error-message">{errorMessageFileUpload}</p>
                    )}
                    <button className="next-button" onClick={nextStep}
                        disabled={!isImageUploaded} 
                    >
                        Siguiente →
                    </button>
                </form>
            )


            }
            <hr />
            {/* Step 2: Pet Details */}
            <form onSubmit={handleSubmit}>
                {
                    step === 2 && (
                        <>
                            <div className="dotted-border-form">
                                <h3 style={{ textDecoration: "underline" }}>Completá con los datos de tu mascota</h3>
                                <label>Nombre de tu mascota:</label>
                                <input
                                    type="text"
                                    value={petName}
                                    onChange={handlePetNameChange}
                                    placeholder="Nombre de tu mascota"
                                    required
                                />
                                <label>Tipo de mascota:</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={petType}
                                    onChange={(e) => {
                                        const formattedType = e.target.value
                                            .toLowerCase()
                                            .replace(/\b\w/g, (char) => char.toUpperCase());
                                        setPetType(formattedType);
                                    }} placeholder="Perro, gato, etc."
                                    required
                                />
                                <label className="after-race">Raza:</label>
                                <input
                                    type="text"
                                    value={petBreed}
                                    onChange={(e) => setPetBreed(e.target.value)}
                                    placeholder="Bulldog Francés, Labrador, Maine Coon"
                                    required
                                />
                                <label>Género:</label>
                                <div className="gender-radio-group inline">
                                    <label>
                                        <input
                                            type="radio"
                                            value="Macho"
                                            checked={petGender === "Macho"}
                                            onChange={(e) => setPetGender(e.target.value)}
                                        />
                                        Macho
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Hembra"
                                            checked={petGender === "Hembra"}
                                            onChange={(e) => setPetGender(e.target.value)}

                                        />
                                        Hembra
                                    </label>
                                </div>
                                <label>Fecha de nacimiento de tu mascota:</label>
                                <input
                                    type="date"
                                    value={dateBirth}
                                    // onChange={(e) => setDateBirth(e.target.value)}
                                    onChange={handleDateChange}
                                    placeholder="Fecha de nacimiento:"
                                    required
                                    className="date-style"
                                />
                                <label className="after-race">Color:</label>
                                <input
                                    type="text"
                                    value={petColor}
                                    onChange={(e) => setPetColor(e.target.value)}
                                    placeholder="Color de tu mascota"
                                    required
                                />
                                <label>Castrado:</label>
                                <div className="gender-radio-group inline">
                                    <label>
                                        <input
                                            type="radio"
                                            value="Si"
                                            checked={sterilized === "Si"}
                                            onChange={(e) => setSterilized(e.target.value)}
                                        />
                                        Si
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="No"
                                            checked={sterilized === "No"}
                                            onChange={(e) => setSterilized(e.target.value)}
                                        />
                                        No
                                    </label>
                                </div>
                                <label>Registro de vacunas:</label>
                                <input
                                    type="text"
                                    value={petVaccine}
                                    onChange={(e) => setPetVaccine(e.target.value)}
                                    placeholder="Vacuna, fecha, otras informaciones"
                                    required
                                />
                                 <label>Fecha de última vacuna:</label>
                                <input
                                    type="date"
                                    value={dateLastVaccine}
                                    // onChange={(e) => setDateBirth(e.target.value)}
                                    onChange={handleDateForVaccine}
                                    placeholder="Fecha de última vacuna:"
                                    required
                                    className="date-style"
                                />

<label>Collar antipulgas:</label>
                                <div className="gender-radio-group">
                                    <label>
                                        <input
                                            type="radio"
                                            value="Si"
                                            checked={fleaCollar === "Si"}
                                            onChange={(e) => setFleaCollar(e.target.value)}
                                        />
                                        Si
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="No"
                                            checked={fleaCollar === "No"}
                                            onChange={(e) => setFleaCollar(e.target.value)}
                                        />
                                        No
                                    </label>
                                </div>
                                {fleaCollar === "Si" && (
                                    <>
                                        <label>Fecha última colocación:</label> {/* New input field */}
                                        <input
                                            
                                            type="date"
                                            value={fleaCollarDate}
                                            // onChange={(e) => setDateBirth(e.target.value)}
                                            onChange={handleDateForFlea}
                                            placeholder="Fecha última colocación:"
                                            required
                                            className="date-style"



                                        />
                                    </>
                                )}


                                 <label>Intolerancia o alergias:</label>
                                <input
                                    type="text"
                                    value={intolerance}
                                    onChange={(e) => setIntolerance(e.target.value)}
                                    placeholder="Intolerancia a medicamentos, alimentos, etc."
                                    required
                                />
                                <label>Carácter:</label>
                                <input
                                    type="text"
                                    value={petCharacter}
                                    onChange={(e) => setPetCharacter(e.target.value)}
                                    placeholder="Apariencia, comportamiento, personalidad"
                                    required
                                />
                                <label>Microchip:</label>
                                <div className="gender-radio-group">
                                    <label>
                                        <input
                                            type="radio"
                                            value="Si"
                                            checked={microChip === "Si"}
                                            onChange={(e) => setMicrochip(e.target.value)}
                                        />
                                        Si
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="No"
                                            checked={microChip === "No"}
                                            onChange={(e) => setMicrochip(e.target.value)}
                                        />
                                        No
                                    </label>
                                </div>
                                {microChip === "Si" && (
                                    <>
                                        <label>Número de microchip</label> {/* New input field */}
                                        <input
                                            type="text"
                                            value={microChipNumber}
                                            onChange={(e) => setMicrochipNumber(e.target.value)}
                                            placeholder="Número de microchip"
                                            required
                                        />
                                    </>
                                )}
                                <button className="next-button" onClick={prevStep}>
                                    ← Anterior
                                </button>
                                <button className="next-button" onClick={nextStep}
                                    disabled={isNextButtonDisabled}
                                >
                                    Siguiente →
                                </button>
                            </div>
                        </>
                    )}
                {
                    step === 3 && (
                        <>
                            <div className="dotted-border-form">
                                <h3 style={{ textDecoration: "underline" }}>Tus datos de contacto</h3>
                                <label>Nombre de contacto</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={ownerName}
                                    onChange={(e) => {
                                        const formattedName = e.target.value
                                            .toLowerCase()
                                            .replace(/\b\w/g, (char) => char.toUpperCase());
                                        setOwnerName(formattedName);
                                    }} placeholder="Nombre de contacto"
                                    required
                                />
                                <label>Email</label> {/* New input field */}
                                <input
                                    type="email"
                                    value={ownerEmail}
                                    onChange={(e) => {
                                        setOwnerEmail(e.target.value); // Directly set the input value to the state

                                    }} placeholder="mi@correo.com"
                                    required
                                />
                                <label>Teléfono de contacto</label> {/* New input field */}
                                <input
                                    type="number"
                                    value={contactPhone}
                                    onChange={(e) => setContactPhone(e.target.value)}
                                    placeholder="Teléfono de contacto"
                                    required
                                />

                                <label>Dirección</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    placeholder="Dirección"
                                    required
                                />
                                <label>Recomendado por</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={recommendedBy}
                                    onChange={(e) => setRecommendedBy(e.target.value)}
                                    placeholder="Petshop, Veterinario, etc"

                                />
                            </div>
                            <div className="dotted-border-form">
                                <h3 style={{ textDecoration: "underline" }}>Datos del veterinario</h3>
                                <label>Nombre del veterinario</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={vetName}
                                    onChange={(e) => setVetName(e.target.value)}
                                    placeholder="Nombre del veterinario"
                                />
                                <label>Teléfono de veterinario</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={vetPhone}
                                    onChange={(e) => setVetPhone(e.target.value)}
                                    placeholder="Teléfono de veterinario"

                                />
                                <label>Dirección de la veterinaria</label> {/* New input field */}
                                <input
                                    type="text"
                                    value={vetAddress}
                                    onChange={(e) => setVetAddress(e.target.value)}
                                    placeholder="Dirección de la veterinaria"
                                />
                                <label>Color chapita:</label>
                                <div className="gender-radio-group inline">
                                    <label>
                                        <input
                                            type="radio"
                                            value="Aluminio"
                                            checked={colorChapita === "Aluminio"}
                                            onChange={(e) => setColorChapita(e.target.value)}
                                        />
                                        Aluminio
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Rosa"
                                            checked={colorChapita === "Rosa"}
                                            onChange={(e) => setColorChapita(e.target.value)}
                                        />
                                        Rosa
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Negro"
                                            checked={colorChapita === "Negro"}
                                            onChange={(e) => setColorChapita(e.target.value)}
                                        />
                                        Negro
                                    </label>
                                </div>
                                <button className="next-button" onClick={prevStep}>
                                    ←Anterior
                                </button>
                            </div>
                            <button type="submit" disabled={isCreating}>
                                {isCreating ? "Enviando..." : "Enviar Formulario"}
                            </button>
                            {/* {isCreating && <p>¡Formulario enviado!</p>} */}
                            {errorMessage && <p className="error-message">{errorMessage}</p>}
                            {successMessage && <p dangerouslySetInnerHTML={{ __html: successMessage }} className="success-message"></p>}

                        </>
                    )} </form>
            <footer className="support-footer">
                <p>   ¿Necesitás ayuda para crear el perfil de tu mascota? Contactanos{" "}
                    <a href="mailto:martinembon9@gmail.com" style={{ textDecoration: 'underline' }}>
                        acá
                    </a>.</p>
            </footer>
        </div>

    );
};

export default CreatePetPublic;
